import { createTheme } from "@mui/material/styles";
import { colors } from "./colors";

// Create a theme instance.
export const theme = createTheme({
  typography: {
    fontFamily: '"Figtree", sans-serif',
  },
  palette: {
    primary: {
      main: colors["fp-primary"], // set your desired color here
    },
  },
});
